import { GameTotalWinCounterProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameTotalWinCounterProperties";
export class TotalWinCounterPortraitProperties extends GameTotalWinCounterProperties {
    constructor() {
        super();
        this.position.set(834, 1774);
        this.backgroundProperties.scale.set(1.05, 0.9);
    }
}
//# sourceMappingURL=TotalWinCounterPortraitProperties.js.map